module.exports = __webpack_public_path__ + "img/miaoshupc.76219ae3.png";